import { render } from "./BannerItemCmpV2.vue?vue&type=template&id=34676680"
import script from "./BannerItemCmpV2.vue?vue&type=script&lang=js"
export * from "./BannerItemCmpV2.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__